import React from "react";
import { useContextData } from "../hooks/useContextData";
import Header from "../components/Header";
import { Typography } from "@mui/material";

const Profile = () => {
  const { theme, userInfo } = useContextData();
  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "#222" : "white",
        color: theme === "dark" ? "#FAFAFA" : undefined,
        height: "100%",
      }}
    >
      <Header />
      <Typography variant="h4" style={{ marginTop: 15, marginBottom: 15 }}>
        Profile
      </Typography>
    </div>
  );
};

export default Profile;
